export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "تفعيل رسائل OTA",
    installIntro:
      "للرد على ضيوف Booking.com / Airbnb من WA Checkin، عليك تثبيت تطبيق",
    installIntroTail: "في مكان الإقامة.",
    installBtn: "تثبيت مراسلة OTA",
    installing: "جارٍ تثبيت وحدة الرسائل…",
    retryLink: "لقد ثبّتُ التطبيق بالفعل، إعادة التحقق",
    loading: "جارٍ تحميل رسائل OTA…",
    empty: "لا توجد رسائل OTA لهذا الحجز.",
    modeAi: "الذكاء الاصطناعي",
    modeManual: "يدوي",
    predefinedHeader: "الردود السريعة",
    predefinedEmpty: "لا توجد ردود مطابقة.",
    inputPlaceholder: "اكتب رسالة أو استخدم / للردود السريعة...",
    attachTitle: "إرفاق صورة",
    senderGuest: "ضيف",
    senderProperty: "مكان الإقامة",
    senderSystem: "النظام",
    senderUnknown: "غير معروف",
    fileFallback: "ملف",
    toastTitle: "رسائل OTA",
    errorTitle: "خطأ",
    loadError: "تعذّر تحميل رسائل OTA.",
    modeErrorDetail: "تعذّر تحديد محادثة OTA. حاول إعادة تحميل الصفحة.",
    modeManualOnTitle: "تم تفعيل الوضع اليدوي",
    modeAiOnTitle: "تم تفعيل وكيل الذكاء الاصطناعي",
    modeManualOnDetail: "ستردّ على الرسائل يدويًا",
    modeAiOnDetail: "سيردّ البوت تلقائيًا",
    modeChangeError: "تعذّر تغيير وضع محادثة OTA",
    sendError: "تعذّر إرسال رسالة OTA.",
    onlyImagesTitle: "الصور فقط",
    onlyImagesDetail: "عبر OTA يمكن إرسال الصور فقط.",
    imageTooBigTitle: "الصورة كبيرة جدًا",
    imageTooBigDetail: "لا يمكن أن تتجاوز الصورة 5 ميجابايت.",
    installNoProperty: "لم يتم العثور على العقار المتصل بـ Channex.",
    installOk: "تم تثبيت التطبيق بنجاح.",
    installError: "تعذّر تثبيت التطبيق.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "اكتب ملاحظة داخلية…",
    saveHint: "⌘ / Ctrl + Enter للحفظ",
    saving: "جارٍ الحفظ…",
    addNote: "إضافة ملاحظة",
    loading: "جارٍ تحميل الملاحظات…",
    emptyTitle: "لا توجد ملاحظات بعد",
    emptyText: "أضف أول ملاحظة داخلية من المربع أعلاه.",
    cancel: "إلغاء",
    save: "حفظ",
    team: "الفريق",
    confirmDelete: "حذف؟",
    yes: "نعم",
    no: "لا",
    editTitle: "تعديل",
    deleteTitle: "حذف",
    loadError: "تعذّر تحميل الملاحظات",
    added: "تمت إضافة الملاحظة",
    saveError: "تعذّر حفظ الملاحظة",
    updated: "تم تحديث الملاحظة",
    updateError: "تعذّر تحديث الملاحظة",
    deleted: "تم حذف الملاحظة",
    deleteError: "تعذّر حذف الملاحظة",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "المتبقّي",
    paidLabel: "المحصّل",
    totalLabel: "الإجمالي",
    loading: "جارٍ تحميل المدفوعات…",
    empty: "لم يُسجَّل أي دفع بعد.",
    addPayment: "إضافة دفعة…",
    fullyPaid: "تم تحصيل الحجز بالكامل",
    recalcTitle: "إعادة الحساب",
    sendWhatsappTitle: "إرسال عبر WhatsApp",
    copyLinkTitle: "نسخ الرابط",
    editAction: "تعديل",
    deleteAction: "حذف",
    modalEditTitle: "تعديل الدفعة",
    modalAddTitle: "إضافة دفعة",
    amountLabel: "المبلغ المطلوب تحصيله",
    fillRemaining: "تحصيل المبلغ المتبقّي ({amount})",
    methodLabel: "طريقة الدفع",
    sendWhatsappCheck: "إرسال الرابط إلى الضيف عبر WhatsApp",
    noteLabel: "ملاحظة (اختياري)",
    notePlaceholder: "مثال: عربون، الدفع عند الوصول…",
    cancel: "إلغاء",
    save: "حفظ",
    generateLink: "إنشاء رابط",
    registerPayment: "تسجيل التحصيل",
    deleteConfirmTitle: "حذف هذه الدفعة؟",
    deleteText1: "سيتم حذف الدفعة بقيمة",
    deleteLinkVoided: "سيتم إلغاء رابط الدفع.",
    deleteIrreversible: "لا يمكن التراجع عن هذا الإجراء.",
    deleteBtn: "حذف الدفعة",
    sendConfirmTitle: "إرسال رابط الدفع؟",
    sendText1: "سيتم إرسال رابط الدفع إلى الضيف عبر WhatsApp لدفع",
    sendBtn: "إرسال الرابط",
    methodCash: "نقدًا",
    methodCard: "بطاقة/جهاز نقاط بيع",
    methodTransfer: "تحويل بنكي",
    methodOta: "مدفوع عبر OTA",
    statusPaid: "محصّل",
    statusPending: "قيد الانتظار",
    statusFailed: "فشل",
    statusCancelled: "ملغى",
    loadError: "تعذّر تحميل المدفوعات.",
    amountRequired: "أدخل مبلغًا.",
    saveError: "تعذّر حفظ الدفعة.",
    deleteError: "تعذّر الحذف.",
    sendLinkError: "تعذّر إرسال الرابط.",
    recalcError: "تعذّرت إعادة الحساب.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "تخصيص غرفة",
    subWithUnitPre: "هذا الحجز في",
    subWithUnitPost: "لا يحتوي بعد على غرفة فعلية مخصّصة.",
    subNoUnit: "لا يحتوي هذا الحجز بعد على غرفة فعلية مخصّصة.",
    loading: "جارٍ البحث عن التوفّر…",
    freePre: "غرف متاحة لـ",
    freePost: "اختر واحدة وخصّصها مباشرة:",
    freeBadge: "متاحة",
    assigning: "جارٍ التخصيص…",
    occupiedNote:
      "{count} غرفة محجوزة في هذه التواريخ | {count} غرف محجوزة في هذه التواريخ",
    noneFreeTitle: "لا توجد أي غرفة متاحة لهذه التواريخ.",
    noFreePre: "جميع الغرف من",
    thisType: "هذا النوع",
    noFreeMid: "محجوزة أو مغلقة في {date}. لتتمكن من تخصيص هذا الحجز،",
    reorganizeBold: "أعد تنظيم الحجوزات",
    noFreeMid2: "لهذا النوع من الغرف من التقويم (زر",
    organizeBtn: "تنظيم",
    noFreeTail: ") لتحرير غرفة.",
    tagMaintenance: "صيانة",
    tagBlocked: "مغلقة",
    theseDates: "هذه التواريخ",
    occupied: "محجوزة",
    assignedOk: "تم تخصيص الغرفة {label} بنجاح.",
    assignError: "تعذّر تخصيص الغرفة.",
    notifyError: "خطأ",
    notifyDone: "تم",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "غرف الحجز",
    typesCount: "{count} نوع | {count} أنواع",
    roomsCount: "{count} غرفة | {count} غرف",
    guestsCount: "{count} ضيف | {count} ضيوف",
    totalLabel: "الإجمالي",
    viewingBadge: "قيد العرض",
    noRoomAssigned: "لا توجد غرفة مخصّصة",
    removeOneRoom: "إزالة غرفة",
    addOneRoom: "إضافة غرفة",
    confirmRemove: "إزالة؟",
    yes: "نعم",
    no: "لا",
    cannotRemoveOnly: "لا يمكنك إزالة الغرفة الوحيدة",
    removeRoomFromBooking: "إزالة هذه الغرفة من الحجز",
    updating: "جارٍ التحديث…",
    theChannel: "القناة",
    otaManaged:
      "تدير هذه الغرفة {channel}: يتم تغيير الكمية والسعر هناك.",
    notifyError: "خطأ",
    notifyDone: "تم",
    qtyUpdated: "تم تحديث الكمية",
    roomRemoved: "تمت إزالة الغرفة من الحجز",
    updateError: "تعذّر تحديث الحجز. حاول مرة أخرى.",
  },
};
